module.exports = __webpack_public_path__ + "static/media/DrSarahFiedler.72e76961.jpg";